import { Peeky } from "./peeky";

/**
 * Google Analytics plug-in
 */
export class GoogleAnalytics {
  private _gatrackers: string[] = [];
  private _hasGa = false;
  
  constructor(private _pk: Peeky) {
  }

  track(debug: boolean, addHostname: boolean, ...trackers: string[]): void;
  track(debug: boolean, ...trackers: string[]): void;
  track(...trackers: string[]): void;
  track(/* tracker, debug */) {
    let i=0;
    let addHostname = false;
    let trackers = [];
    let debug = false;
    if (typeof(arguments[i]) === 'boolean') debug = arguments[i++];
    if (typeof(arguments[i]) === 'boolean') addHostname = arguments[i++];
    while (typeof(arguments[i]) === 'string') trackers.push(arguments[i++]);

    // No trackers found
    if (trackers.length <= 0) {
      return;
    }
    
    let trackeroffset = this._gatrackers.length;
    this._gatrackers = this._gatrackers.concat(trackers);

    let ga = (<any>window).ga = (<any>window).ga || function(){
      (ga.q=ga.q||[]).push(arguments)
    };
    ga.l = +new Date;

    if (!this._hasGa) {
      this._hasGa = true;

      let load = () => {
        let url = debug ? 'https://www.google-analytics.com/analytics_debug.js' : 'https://www.google-analytics.com/analytics.js';
        let head = document.getElementsByTagName('head')[0];
        let script = document.createElement('script');
        //script.onload = function() {
        //};
        script.src = url;
        head.appendChild(script);
      };

      if (/complete|interactive|loaded/.test(document.readyState)) {
        load();
      } else {
        document.addEventListener('DOMContentLoaded', load, false);
      }
    }
    
    let prefix = addHostname ? '/' + window.location.hostname : '';
    
    for (let i=0; i<trackers.length;i++) {
      ga('create', trackers[i], 'auto', { name: 't' + (i+trackeroffset) });
    }
    ga('set', 'anonymizeIp', true); 
    ga('set', 'allowAdFeatures', false);

    this._pk.on('postPushState', function(param) {
      if (!param.pushPath) {
        return;
      }
      for (let i=0; i<trackers.length; i++) {
        ga('t' + (i+trackeroffset) + '.send', 'pageview', { page: prefix + param.pushPath });
      }
    });
  }

  event(category, action, value) {
    let ga = (<any>window).ga = (<any>window).ga || function(){
      (ga.q=ga.q||[]).push(arguments);
    }
    ga.l=+new Date;
    let trackers = this._gatrackers || [];
    for (let i=0; i<trackers.length; i++) {
      ga.push(trackers[i] + '.send', 'event', category, action, value);
    }
  }
}